import {QueryClient} from '@tanstack/react-query';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            placeholderData: (prev: unknown) => prev,
            staleTime: 600000,
            retry: 1
        }
    }
});

export default queryClient;
